import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

// Define dynamic headers statically here

export const tableInitialValues = (subSection: SubSection) => ({
  title: subSection.title || "",
  headers: subSection.attrs?.tableData?.headers || [""], // Start with one empty header
  rows: subSection.attrs?.tableData?.rows || [[""]], // Start with one empty row

});

// Example of dynamic row validation
export const tableValidationSchema = Yup.object({
  headers: Yup.array()
  .of(Yup.string())
  .min(2, "At least one header is required"), // Ensures at least one header exists

rows: Yup.array()
  .of(
    Yup.array()
      .of(Yup.string())
      // .min(2, "Each row must have at least one cell") // Ensures rows are not empty
  )
  .min(1, "At least one row is required"),
});
